// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".registration-notice[data-v-6236871f]{background-color:#efefef;margin:1em 0 .5em;padding:.5em 0;border-radius:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
